import { dictionaryService } from '../../../dataFlow';
import { useDictionaryItem, useParameter, yearToCropYearShort } from '../../../shared'; 

export function useSlideSubtitle() {
  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", (parameterValues));
  const year = calendarName ? Number(calendarName) : (new Date().getFullYear() - 1);
  const subtitle = `${yearToCropYearShort(year)} vs. ${yearToCropYearShort(year - 1)}`; 
  return subtitle;
}